import React, { createContext, useState, useContext, useEffect, ReactNode } from 'react';
import LocalStorageUtil from '../utils/localStorageUtil';
import { storageKeys } from '../utils/constants';
import apiService from '../apiService/ApiService';
import { AxiosResponse, GetWorkerTimerRunningStatus } from '../utils/urlConst';

interface TimerContextType {
    startTime: number | null;
    isTimerOn: boolean;
    setStartTime: (time: number | null) => void;
    setIsTimerOn: (isOn: boolean) => void;
    selectedProjectForLog: ProjectItem;
    setSelectedProjectForLog: (item: ProjectItem) => void;
    setSelectedProjectIdForNavigation: (id: number | null) => void;
    selectedProjectIdForNavigation: number | null;
    isResetTimer: boolean;
    setIsResetTimer: (isReset: boolean) => void,
    isAuthenticated: boolean;
    setIsAuthenticated: (isAuthenticated: boolean) => void;
}
export interface ProjectItem {
    id: number | null;
    name: string | null
}

const TimerContext = createContext<TimerContextType | undefined>(undefined);

export const useTimerContext = () => {
    const context = useContext(TimerContext);
    if (context === undefined) {
        throw new Error('useTimerContext must be used within a TimerProvider');
    }
    return context;
};

interface TimerProviderProps {
    children: ReactNode;
}

export const TimerProvider: React.FC<TimerProviderProps> = ({ children }) => {
    const [startTime, setStartTime] = useState<number | null>(() => {
        const savedStartTime = LocalStorageUtil.getItem(storageKeys.timerStartTime, null);
        return savedStartTime ? parseInt(savedStartTime, 10) : null;
    });

    const [isTimerOn, setIsTimerOn] = useState(() => {
        const savedIsTimerOn = LocalStorageUtil.getItem(storageKeys.timerIsRunning, null);
        return savedIsTimerOn ? JSON.parse(savedIsTimerOn) : false;
    });

    const [selectedProjectForLog, setSelectedProjectForLog] = useState(() => {
        const selectedProjectForLog = LocalStorageUtil.getItem(storageKeys.selectedProjectForLog, null);
        return selectedProjectForLog ? JSON.parse(selectedProjectForLog) : {
            id: null,
            name: null,
        };
    });
    const [selectedProjectIdForNavigation, setSelectedProjectIdForNavigation] = useState(() => {
        const selectedProjectId = LocalStorageUtil.getItem(storageKeys.selectedProjectIdForNavigation, null);
        return selectedProjectId ? parseInt(selectedProjectId) : null;
    });

    const [isAuthenticated, setIsAuthenticated] = useState(() => {
        const isAuthenticated = LocalStorageUtil.getItem(storageKeys.isAuthenticated, null);
        return isAuthenticated ? isAuthenticated : false;
    });

    const [isResetTimer, setIsResetTimer] = useState<boolean>(false);

    useEffect(() => {
        LocalStorageUtil.setItem(storageKeys.timerStartTime, startTime?.toString() ?? '');
    }, [startTime]);

    useEffect(() => {
        LocalStorageUtil.setItem(storageKeys.timerIsRunning, JSON.stringify(isTimerOn));
    }, [isTimerOn]);

    useEffect(() => {
        LocalStorageUtil.setItem(storageKeys.selectedProjectForLog, JSON.stringify(selectedProjectForLog));
    }, [selectedProjectForLog]);

    useEffect(() => {
        LocalStorageUtil.setItem(storageKeys.selectedProjectIdForNavigation, selectedProjectIdForNavigation);
    }, [selectedProjectIdForNavigation]);

    useEffect(() => {
        LocalStorageUtil.setItem(storageKeys.isAuthenticated, isAuthenticated);
    }, [isAuthenticated]);
    // const resetTimer = () => {
    //     const startTime = new Date().getTime()
    //     setStartTime(startTime)
    // }


    useEffect(() => {
        console.log("isAuthenticated TimerContext ******", isAuthenticated)
        if (isAuthenticated) {
            getWorkerLogRunningStatus()
        }
    }, [isAuthenticated])

    // fetch WorkerLogRunningStatus api call
    const getWorkerLogRunningStatus = async () => {
        try {
            let userToken = LocalStorageUtil.getItem(storageKeys.authToken, "");
            let userId = LocalStorageUtil.getItem(storageKeys.userId, "");

            let jsondata = JSON.stringify({
                token: userToken,
                user_id: userId,
            });

            apiService.setAuthToken(userToken);
            const responseJson: AxiosResponse | null = await apiService.post(GetWorkerTimerRunningStatus, jsondata);
            if (responseJson?.hasOwnProperty('status') && responseJson?.status_code === 1) {
                console.log("response", responseJson);
                if (responseJson?.data?.log_date) {
                    const [hours, minutes, seconds] = responseJson?.data?.start_time.split(":").map(Number)
                    const today = new Date()
                    today.setHours(hours, minutes, seconds, 0)
                    const startTime = today.getTime()
                    setStartTime(startTime);
                    setIsTimerOn(true);
                    const selectedProject = { id: responseJson?.data?.project_id, name: responseJson?.data?.project_name };
                    setSelectedProjectForLog(selectedProject)
                } else {
                    setIsTimerOn(false);
                    setStartTime(null);
                    setSelectedProjectForLog({
                        id: null,
                        name: null,
                    })
                }
            }
        } catch (error) {
            console.log("error fetchig timer")
        }
    };


    const value = {
        startTime,
        isTimerOn,
        setStartTime,
        setIsTimerOn,
        selectedProjectForLog,
        setSelectedProjectForLog,
        selectedProjectIdForNavigation,
        setSelectedProjectIdForNavigation,
        isResetTimer,
        setIsResetTimer,
        isAuthenticated,
        setIsAuthenticated
    };

    return <TimerContext.Provider value={value}>{children}</TimerContext.Provider>;
};

